import { ref, Ref } from 'vue';
import type { NavItem } from '@/modules/core/nav/models/NavItem';

export const navItems: Ref<NavItem[]> = ref([]);
export const headerNavItems: Ref<NavItem[]> = ref([]);
export const footerNavItems: Ref<NavItem[]> = ref([]);
